function Analytics() {
  return (
    <div>
      <h1>Analytics</h1>
      <p>Welcome to Club OS Analytics</p>
    </div>
  );
}

export default Analytics;